var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',_vm._b({attrs:{"options":_vm.items},on:{"input":function($event){return _vm.selected($event)}},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}},'b-form-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }